import React from "react"
import $ from "jquery"
import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"

import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
} from "react-bootstrap"

function Tools() {
  const history = useHistory()

  const redirectToUrl = async (e) => {
    console.log($(e.target).data("url"))
  }

  useEffect(() => {
    $(document).ready(function () {
      $(".button-card").click(function () {
        var url = $(this).data("url")
        history.push(url)
      })
    })
  }, [])

  return (
    <>
      <style></style>
      <Row>
        <Col md='3'>
          <div
            className='button-card bc-purple'
            data-url='/admin/app/invoice-to-excel'
          >
            <h4>Invoice to Excel</h4>
            <p>This tool is use for converting invoice to an excel template.</p>
          </div>
        </Col>
        <Col md='3'>
          <div
            className='button-card bc-red'
            data-url='/admin/app/invoice-to-p44'
          >
            <h4>Invoice to P44 Excel</h4>
            <p>
              This tool is use for converting invoices to P44 excel template.
            </p>
          </div>
        </Col>

        <Col md='3'>
          <div
            className='button-card bc-green'
            data-url='/admin/app/signature-generator'
          >
            <h4>Signature Generator</h4>
            <p>Create responsive signature for your email here.</p>
          </div>
        </Col>

        <Col md='3'>
          <div className='button-card bc-purple' data-url='/admin/app/bonus'>
            <h4>Bonus Calculator</h4>
            <p>
              Bonus Calculator is automated tool designed to streamline the
              bonus calculation process.{" "}
            </p>
          </div>
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col md='3'>
          <div
            className='button-card bc-purple'
            data-url='/admin/app/price-predictor'
          >
            <h4>Price Predictor</h4>
            <p>Test our pricing model for Pulsar and provide feedback.</p>
          </div>
        </Col>
        <Col md='3'>
          <div className='button-card bc-red' data-url='/admin/app/aging'>
            <h4>Aging Report</h4>
            <p>
              Drill down into the Aging Report with data provided by QuickBooks
            </p>
          </div>
        </Col>
        <Col md='3'>
          <div
            className='button-card bc-green'
            data-url='/admin/app/grossmargin_table'
          >
            <h4>Gross Margin</h4>
            <p>View details of specific orders</p>
          </div>
        </Col>

        <Col md='3'>
          <div
            className='button-card bc-green'
            data-url='/admin/app/automations'
          >
            <h4>Automations</h4>
            <p>Everything regarding automoation.</p>
          </div>
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col md='3'>
          <div
            className='button-card bc-purple'
            data-url='/admin/app/load-life-cycle'
          >
            <h4>Load's Life Cycle</h4>
            <p>
              An overview of an order's lifecycle. Starting from All Orders and
              ending in Old Orders
            </p>
          </div>
        </Col>
        <Col md='3'>
          <div
            className='button-card bc-purple'
            data-url='/admin/app/bus-utilization'
          >
            <h4>Bus Utilization</h4>
            <p>
              Bus utilization history reports and visualizations
            </p>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default Tools
